import { render, staticRenderFns } from "./edit_groups.vue?vue&type=template&id=3d66be71&scoped=true&"
import script from "./edit_groups.vue?vue&type=script&lang=ts&"
export * from "./edit_groups.vue?vue&type=script&lang=ts&"
import style0 from "./edit_groups.vue?vue&type=style&index=0&id=3d66be71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d66be71",
  null
  
)

export default component.exports